import { render } from "./TransactionCard.vue?vue&type=template&id=d88e72b6"
import script from "./TransactionCard.vue?vue&type=script&lang=js"
export * from "./TransactionCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__